module.exports = __webpack_public_path__ + "img/xz_line_tail_1.16d19674.svg";